import { render, staticRenderFns } from "./DefaultRun.vue?vue&type=template&id=a36f5f64"
import script from "./DefaultRun.vue?vue&type=script&lang=js"
export * from "./DefaultRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports